
//STYLES
import { Capa_resumo } from "./style"

//APP
import { ConsultoriaItensTypes } from "../../../../../../../../../../services/Cliente";
import { obterLogo } from "../capa/meta";

//PROPS
interface Props {
    /**Nome que será exibido na capa do book */
    responsavel: string;
    /**Texto exibido abaixo do nome do responsável
     * 
     * Pode ser a formação academica, ocupação ou qualquer ou descrição
     */
    formacao: string;
    /**Dados da consultoria armazenados no `useAccess()` */
    dados_consultoria: ConsultoriaItensTypes;
}

/**`Pagina 01:` Capa do Book de fertilidade resumido  */
export const CapaBookResumo: React.FC<Props> = ({ responsavel, formacao, dados_consultoria }) => {
    
    return (
        <Capa_resumo>

            <div className="Capa__responsavel">
                <h2 className="Capa__responsavel__nome">
                    {responsavel}
                </h2>
                <span className="Capa__responsavel__formacao">
                    {formacao}
                </span>
            </div>
            
            <img className="Capa__logo" src={obterLogo() ?? dados_consultoria?.logo_url} alt='logo' />
            

        </Capa_resumo>
    )
}